import { render, staticRenderFns } from "./AddHospitalSpecialites.vue?vue&type=template&id=37af2859"
import script from "./AddHospitalSpecialites.vue?vue&type=script&lang=js"
export * from "./AddHospitalSpecialites.vue?vue&type=script&lang=js"
import style0 from "./AddHospitalSpecialites.vue?vue&type=style&index=0&id=37af2859&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports